import { UseFormReturn } from "react-hook-form";
import { DTOModule } from "../../types/building";
import SelectEditor from "../Global/Editors/SelectEditor";
import { IModuleVärmePrimärFjärrConfig } from "../../types/ModuleDatas";
import StaticBox from "../Global/StaticBox";
import NumberEditor from "../Global/Editors/NumberEditor";
import { nameof } from "../Global/Utils";
import CheckboxEditor from "../Global/Editors/CheckboxEditor";
import { MapTooltip } from "../../types/globalData";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigVarmePrimarFjarr = ({ module, data, formHook }: IProps) => {
  const harFlodestaxa = formHook.watch(nameof<IModuleVärmePrimärFjärrConfig>("harFlödestaxa"));
  const användSchablon = formHook.watch(nameof<IModuleVärmePrimärFjärrConfig>("användSchablon"));
  return (
    <>
      <div className="row ml-0">
        {/* <div className="col-lg-12">ConfigVarmePrimarFjarr</div>
        <div className="col-lg-12">
          <StaticBox label="Benämning på system" text={module.name}></StaticBox>
        </div> */}
        <div className="col-lg-12">
          <SelectEditor
            label="Ange om fjärrvärmeleverantören har flödestaxa"
            formHook={formHook}
            fieldName={nameof<IModuleVärmePrimärFjärrConfig>("harFlödestaxa")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_harFlödestaxa")}
            items={["Nej", "Ja"]}
          ></SelectEditor>
        </div>
        {harFlodestaxa === "Ja" ? (
          <>
            <div className="col-lg-12">
              <CheckboxEditor
                label="Använd schablontaxa"
                formHook={formHook}
                fieldName={nameof<IModuleVärmePrimärFjärrConfig>("användSchablon")}
                tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_användSchablon")}
              ></CheckboxEditor>
            </div>
            <div className="col-lg-12">
              <NumberEditor
                label="Ange Flödestaxa: Kronor & öre per kubikmeter"
                step={0.1}
                fieldName={nameof<IModuleVärmePrimärFjärrConfig>("flödestaxa")}
                tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_flödestaxa")}
                isDisabled={användSchablon}
                formHook={formHook}
                options={{
                  validate: {
                    required: (v) => {
                      return !v ? "Måste fyllas i" : undefined;
                    },
                  },
                }}
              ></NumberEditor>
            </div>
          </>
        ) : (
          <></>
        )}
        {harFlodestaxa === "Ja" && !användSchablon ? <></> : <></>}
      </div>
    </>
  );
};

export default ConfigVarmePrimarFjarr;
